const sliderConfigs = [
  {
    key: "chaos",
    label: "Chaos Factor",
    proVersion: false,
    default: 0.1
  },
  {
    key: "grain",
    label: "grain Factor",
    proVersion: false,
    default: 0.1
  },
  {
    key: "scale",
    label: "scale Factor",
    proVersion: true,
    default: 0.2
  },
  {
    key: "tuning",
    label: "tuning factor",
    proVersion: true,
    default: 0.1
  }
]

export default sliderConfigs;